export function slickSliders() {
  var slider = jQuery(".sliderexample-slick-slider");
  jQuery('.sliderexample-prev').click(function () {
    jQuery('.sliderexample-slick-slider').slick('slickPrev');
  });
  jQuery('.sliderexample-next').click(function () {
    jQuery('.sliderexample-slick-slider').slick('slickNext');
  });
  slider.slick({
    infinite: false,
    slidesToShow: 3,
    // Display 3 slides at a time (no decimal)
    slidesToScroll: 3,
    // Scroll 3 slides at a time
    arrows: false,
    dots: false,
    swipe: true,
    adaptiveHeight: true,
    prevArrow: jQuery('.sliderexample-prev'),
    nextArrow: jQuery('.sliderexample-next'),
    variableWidth: false,
    // Disable variable width to ensure consistent slide width
    cssEase: 'ease-in-out',
    speed: 2000,
    // Default speed for larger screens
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        // Show 2 slides at a time for medium screens
        slidesToScroll: 2,
        speed: 1500 // Faster speed for medium screens
      }
    }, {
      breakpoint: 770,
      settings: {
        slidesToShow: 1,
        // Show 1 slide at a time for smaller screens
        slidesToScroll: 1,
        speed: 1000 // Even faster speed for small screens
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        // Single slide on mobile screens
        slidesToScroll: 1,
        speed: 500 // Maximum speed for mobile screens
      }
    }]
  });

  // Refresh and reapply styles on window resize
  jQuery(window).on('resize', function () {
    slider.slick('refresh');
  });
}